import classNames from 'classnames';
import { Container } from 'yoso';
import styles from './ChallengeGuidePage.module.scss';

import { ChallengeGuide } from '~/components/Challenge/Guide/ChallengeGuide';
import { Page, PageProps } from '~/components/Page';

export type ChallengeGuidePageProps = PageProps;

export const ChallengeGuidePage = ({ className, ...props }: ChallengeGuidePageProps) => (
  <Page
    className={classNames(styles.root, className)}
    {...props}
    data-event-page_name="challenge_guide">
    <Container margin="auto">
      <ChallengeGuide />
    </Container>
  </Page>
);
